var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-base',{attrs:{"width":_vm.size + 'px',"fill":_vm.color,"viewBox":"0 0 24 24"}},[_c('g',[_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"d":"M19 21H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1zm-6-2h5V9.157l-6-5.454-6 5.454V19h5v-6h2v6z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }